import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SquirrelTabs, TENANTTABS } from 'projects/shared/src/lib/models/SquirrelTabs';
import { TenantDto, TenantResolved } from 'projects/shared/src/lib/models/TenantDto';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';

@Component({
  selector: 'edit-tenant',
  templateUrl: './edit-tenant.component.html',
  styleUrls: ['./edit-tenant.component.scss']
})
export class EditTenantComponent implements OnInit {

  tabs: SquirrelTabs[] = [];
  pageTitle!:string;

  tenantDto!:TenantDto;

  constructor(private route: ActivatedRoute,
    private oauthService: OAuthServiceService,
    public translate:TranslateService,
    private notificationService: NotificationService) { }

  ngOnInit(): void {
    //this.tabs = TENANTTABS;
    this.route.data.subscribe((data: any) => {
      const resolvedData: TenantResolved = data['resolvedData'];
      this.tenantDto = resolvedData.tenantDto;
      this.pageTitle = "Mandant " + resolvedData.tenantDto.displayName
    },
    // error
    );
  }
}
